import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IGroundActionProps } from "./GroundAction.props";

const styles = {
  primary:
    "border-primary bg-primary text-primary-foreground hover:border-charcoal-green-ink hover:bg-charcoal-green-ink",
  secondary:
    "border-weathered-steel bg-transparent text-foreground hover:border-primary hover:bg-primary hover:text-primary-foreground",
  ghost:
    "border-transparent bg-transparent text-primary underline underline-offset-4 hover:underline-offset-8",
  destructive:
    "border-oxidized-orange bg-oxidized-orange text-primary-foreground hover:border-charcoal-green-ink hover:bg-charcoal-green-ink",
} as const;

export const GroundAction = ({ action, className }: IGroundActionProps) => {
  const Link = getComponent("Link");
  return (
    <Link
      aria-label={action.accessibilityLabel || undefined}
      className={cn(
        "inline-flex min-h-11 items-center justify-center border px-4 py-3 font-ground-mono text-xs font-medium leading-[1.4] transition-[background-color,border-color,color,text-underline-offset] duration-200 ease-out focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
        styles[action.style || "primary"],
        className,
      )}
      href={action.href}
      rel={action.openInNewTab ? "noopener noreferrer" : undefined}
      target={action.openInNewTab ? "_blank" : undefined}
    >
      {action.label}
    </Link>
  );
};

GroundAction.displayName = "Content::GroundAction";
